export default __webpack_public_path__ + "static/media/blogging.82f46f25.svg";